import {
  webDomain, ciamDomain, ciamAppName, ciamClientId, ciamRedirectUri, ciamRedirectUriForLogout,
} from '../config/resetConfigs';

export const getDomain = () => (webDomain.substr(0, 4) === 'http' ? webDomain
  : `${window.location.protocol || 'https:'}//${webDomain}`);

export const getCiamDomain = () => ciamDomain;
export const getCiamAppName = () => ciamAppName;
export const getCiamClientId = () => ciamClientId;
export const getCiamRedirectUri = () => ciamRedirectUri;
export const getCiamRedirectUriForLogout = () => ciamRedirectUriForLogout;
